import { useState, useEffect } from "react";
import { useProfile } from "../../../services/hooks/getApi";
import { ShimmerThumbnail } from "react-shimmer-effects";

const ProfileTab = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [data, setData] = useState({
    crypto: null,
    bank: null,
    upi: null,
  });
  const [fetchLoading, setFetchLoading] = useState(true);

  const handleShow = (section) => {
    setActiveSection(section);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const handleSave = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const newData = Object.fromEntries(formData);
    setData((prev) => ({ ...prev, [activeSection]: newData }));
    handleClose();
  };

  //   ======getting profile data====
  const { data: profile, isLoading } = useProfile();

  useEffect(() => {
    if (!isLoading) {
      setFetchLoading(false);
    }
  }, [isLoading]);
  // console.log("Profile Data:....................................", profile);

  //    console.log("Profile Data:", profile);
  return (
    <>
      {fetchLoading ? (
        <div className="shimmer-container">
          <div className="shimmer-effect">
            <ShimmerThumbnail row={2} col={2} card frameHeight={1000} />
          </div>
        </div>
      ) : (
        <div className="container mt-4">
          <h5 className="text-uppercase">Personal Information</h5>
          <div className="personal-info">
            <p>
              <strong>Full Name:</strong> {profile?.FullName || "..."}
            </p>
            <p>
              <strong>Email:</strong> {profile?.Email || "..."}
            </p>
            <p>
              <strong>Phone Number:</strong> {profile?.Phone || "..."}
            </p>
            <p>
              <strong>AccountID:</strong> {profile?.AccountID || "..."}
            </p>
            <p>
              <strong>ReferralID:</strong> {profile?.ReferralID || "..."}
            </p>
            <p>
              <strong>Account_Type:</strong> {profile?.Account_Type || "..."}
            </p>
          </div>{" "}
        </div>
      )}
    </>
  );
};

export default ProfileTab;
